import { DeploymentsTable } from '@app/pages/Deployments/components';
import React from 'react';
import { useGetDeploymentsForCluster } from 'src/query/deployments';

const ClusterDeployments = ({ refresh, clusterId }: { refresh: string; clusterId: string }) => {
  const {
    data: clusterDeploys = [],
    error: deploymentsError,
    isLoading,
    refetch,
  } = useGetDeploymentsForCluster({ pathParams: { realm: 'self', clusterId } });

  return (
    <DeploymentsTable
      refresh={refresh}
      deploys={clusterDeploys}
      error={deploymentsError}
      isLoading={isLoading}
      refetch={refetch}
    />
  );
};

export default ClusterDeployments;
